/* unplugin-vue-components disabled */import { render } from "./xradioGroup.vue?vue&type=template&id=3c431760"
import script from "./xradioGroup.vue?vue&type=script&lang=js"
export * from "./xradioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__